import { Injectable } from '@angular/core';
import { IConfigGlobale } from '../../modelli/config-globale.model';
import { IConfigMappa } from '../../modelli/config-mappa.model';
import { IConfigLogAttivita } from '../../modelli/config-log-attivita.model';
import { IConfigListaAnalisi } from '../../modelli/config-lista-analisi.model';

import configGlobale from 'src/assets/config/config-globale.dev.json';
import configMappa from 'src/assets/config/config-mappa.dev.json';
import configLogAttivita from 'src/assets/config/config-log-attivita.dev.json';
import configListaAnalisi from 'src/assets/config/config-lista-analisi.dev.json';


/** Servizio che carica e mette a disposizione i file di configurazione dentro la cartella assets/config */
@Injectable({
   providedIn: 'root'
})
export class ConfigService {

   /** json di configurazioni globali */
   public getConfigGlobale(): IConfigGlobale {
      return configGlobale as IConfigGlobale;
   }

   /** json di configurazioni della mappa */
   public getConfigMappa(): IConfigMappa {
      return configMappa as IConfigMappa;
   }

   /** json di configurazioni del log attivita */
   public getConfigLogAttivita(): IConfigLogAttivita {
      return configLogAttivita as IConfigLogAttivita;
   }

    /** json di configurazioni della lista analisi per la Ricerca Analisi */
    public getConfigListaAnalisi(): IConfigListaAnalisi {
      return configListaAnalisi as IConfigListaAnalisi;
   }

   /** costruttore */
   constructor() { }

}
